module.exports = __webpack_public_path__ + "static/media/person-solid.7e294150.svg";